import { Form } from "@ant-design/compatible";

import FieldbookForm from "./FieldbookForm";

export default Form.create({
  name: "fieldbookForm",
})(FieldbookForm);
